import {Link, Typography} from "@mui/material"
import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY, breakpoints} from "@next/ux-fabric"

export const Li = styled("li")`
    width: 100%;

    a {
        color: ${({theme}) => theme.uxfabric.components.link.inherit.enabled.textColor};
        text-decoration: none;
        padding: 0.375rem 0.5rem 0.375rem 0;
        margin: 0.125rem 0;
        display: inline-block;
        font-size: 0.875rem;
        line-height: 1.5;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        @media (min-width: ${breakpoints.values.md}px) {
            width: 16.875rem;
        }
        :hover {
            text-decoration: underline;
        }
        font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
        font-weight: ${({theme}) => theme.uxfabric.global.body3.fontWeight};
        font-size: ${({theme}) => theme.uxfabric.global.body3.fontSize};
    }
`

export const Ul = styled("ul")`
    @media (max-width: ${breakpoints.values.md}px) {
        width: 100%;
    }
`
export const NoSearchText = styled(Typography)`
    margin-top: 0.75rem;
    font-family: ${({theme}) => `${theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
`

export const TextLink = styled(Link)(({theme}) => ({
    "&:hover": {
        color: theme.uxfabric.components.link.inherit.enabled.textColor,
    },
}))
